/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
import Reflux from 'reflux';

import type { Store } from 'stores/StoreTypes';
import { singletonActions, singletonStore } from 'logic/singleton';
import OriginaCustomersStore from 'stores/customs/CustomersStore';
import { SessionActions } from 'stores/sessions/SessionStore';

export const CustomersActions = singletonActions(
  'views.Customers',
  () => Reflux.createActions(['refresh'] as const),
);

export type Customer = {
  id: string;
  name: string;
};
export type CustomerStoreState = {
  customers: Array<Customer>;
};

export const CustomersStore: Store<CustomerStoreState> = singletonStore(
  'views.Customers',
  () => Reflux.createStore({
    listenables: [CustomersActions],
    customers: [],
    init() {
      this.refresh();

      SessionActions.logout.completed.listen(() => this.clear());
    },
    getInitialState() {
      return this._state();
    },
    refresh() {
      OriginaCustomersStore.listCustomers().then((result) => {
        this.customers = result;
        this._trigger();
      });
    },
    clear() {
      this.customers = [];
      this._trigger();
    },
    _state() {
      return {
        customers: this.customers,
      };
    },
    _trigger() {
      this.trigger(this._state());
    },
  }),
);
